import React, { useState } from "react";

export default function Memer() {
  const [name, setName] = useState("");
  const [text, setText] = useState("");

  const filledName = name.trim() !== "" ? name : "Default Name";
  const filledText = text.trim() !== "" ? text : "Default challenge text.";

  return (
    <div className="surface-body mc-wrap">
      <header className="mc-header">
        <h1 className="mc-title">Memer Playground</h1>
        <p className="mc-sub">Type your meme name & text below 👇</p>
      </header>

      <div style={{ marginBottom: "1.5rem" }}>
        <label>
        <div className="mc-h2" style={{ marginBottom: 6 }}>Name</div>
            <input
            className="memer-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Írd be a nevet (pl. The Fortis)"
            />
        </label>
        <label>
            <div className="mc-h2" style={{ marginBottom: 6 }}>Text</div>
            <textarea
            className="memer-textarea"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Írd be a szöveget (pl. rövid kihívás leírás)"
            />
        </label>
      </div>

      {/* Live rendered design (NOT code block) */}
      <section className="mc-section">
        <h2 className="mc-h2">Challenges</h2>
        <ul className="mc-list mc-list--grid">
          <li className="mc-card">
            <div className="mc-card-head">
              <span className="mc-chip">{filledName}</span>
              <span className="mc-pill mc-pill--alt">Challenge</span>
            </div>
            <div className="mc-card-body">{filledText}</div>
          </li>
        </ul>
      </section>
    </div>
  );
}
